import React, { useEffect, useState } from 'react'

import classes from "./AutomationsGrid.module.css";
import Card from './Card';
import LockContentLayout from '../UI/Cards/Automations/VirutalSources/SmartLocks/LockContentLayout';
import CreateAutomation from '../UI/Cards/Automations/EditAutomations/CreateAutomation';
import CreateVirtualSource from '../UI/Cards/Automations/VirutalSources/CreateVirtualSource';
import CametContentLayout from '../UI/Cards/Automations/VirutalSources/Camect/CametContentLayout';
import SigFoxContentLayout from '../UI/Cards/Automations/VirutalSources/Sigfox/SigFoxContentLayout';
import EfentoContentLayout from '../UI/Cards/Automations/VirutalSources/Efento/EfentoContentLayout';
import GatewayContentLayout from '../UI/Cards/Automations/VirutalSources/Gateway/GatewayContentLayout';
import { clearDeviceLogs } from '../../Api Methods/Api';
import DavantisContentLayout from '../UI/Cards/Automations/VirutalSources/Davantis/DavantisContentLayout';
import IntegrationContentLayout from '../UI/Cards/Automations/VirutalSources/Integrations/IntegrationContentLayout';
import LiveViewContentLayout from '../UI/Cards/Automations/VirutalSources/LiveView/LiveViewContentLayout';



const VirtualSourcesGrid = ({ Camects, davantis, OutPutsPinNames, InputsPinNames, iglooLocks, fetchVirtualSources, HandleSelectCamectModalForm, setShowVirtualSource, firmware, sigfoxSensors, efentoSensors, gateways, camectIntegrationType, setHasDeviceChanged, supportsCamect, integrations, siteType, supportsLiveView, liveViewCameras, successVisible, setSuccessVisible}) => {
    let camectLength = 0;
    let davantisLength = 0;
    let iglooLocksLength = 0;
    let sigfoxSensorsLength = 0;
    let efentoSensorsLength = 0;
    let gatewaysLength = 0;
    let integrationsLength = 0
    let liveViewCamerasLength = 0

    console.log(gateways)
    console.log(efentoSensors)
    console.log(Camects)
    console.log(liveViewCameras)
    console.log(iglooLocks)
    console.log(integrations)
    console.log(InputsPinNames)
    console.log(OutPutsPinNames)

    const Firmware = firmware.split('.')
    const firmwareMajor = Firmware[0]
    const firmwareMinor = Firmware[1]
    const numInput = InputsPinNames.length

    if (Camects !== null) {
        camectLength = Camects.length;
    }

    if (davantis.length > 0 && davantis[0] != null ){
        davantisLength = davantis[0].davantises.length;
    }

    if (iglooLocks !== null && iglooLocks !== undefined) {
        iglooLocksLength = iglooLocks.length;
    }

    if (sigfoxSensors !== null) {
        sigfoxSensorsLength = sigfoxSensors.length;
    }

    if (efentoSensors !== null){
        efentoSensorsLength = efentoSensors.length;
    }

    if (gateways !== null){
        gatewaysLength = gateways.length;
    }

    if (integrations !== null) {
        integrationsLength = integrations.length;
    }

    if (liveViewCameras !== null) {
        liveViewCamerasLength = liveViewCameras.length;
    }

    const NumberOfItemsInVirutalSourcesArray = camectLength;
    const gridStyleConditional = NumberOfItemsInVirutalSourcesArray < 4 && "flex"

    return (
        <ul className={classes["grid-ul"]}>

            <Card className={classes.cardSourcesDevices}>
                <CreateVirtualSource 
                    HandleSelectCamectModalForm={HandleSelectCamectModalForm} 
                    numInput={numInput} 
                    firmwareMajor={firmwareMajor} 
                    firmwareMinor={firmwareMinor}
                    supportsCamect={supportsCamect}
                    siteType={siteType}
                    supportsLiveView={supportsLiveView}
                />
            </Card>

            {iglooLocks && iglooLocks.map((lock, index) => {
                const outputPinName = OutPutsPinNames.filter(Pin => Pin.Pin == lock.outputPin);

                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <LockContentLayout outputPinName={outputPinName} iglooLocks={lock} setRefreshVirtualSources={fetchVirtualSources} setHasDeviceChanged={setHasDeviceChanged} />
                    </Card>
                )
            })}

            {Camects[0].camects !== null && Camects[0].camects.map((camect, index) => {

                // filter out Pulse Outputs
                const Outputs = OutPutsPinNames.filter((OutPut, index) => OutPut.type == 'LATCH' || OutPut.type == 'VIRTUAL_LATCH');

                // Filter out output pins with assigned smartlocks
                const LatchOutputs = Outputs.filter(output => {
                    return iglooLocks.every(lock => !lock || lock.outputPin != output.Pin);
                });

                let allPins;

                if (firmwareMajor == '1' && firmwareMinor >= '9' || firmwareMajor > 1) {
                    // adding outputs and inputs into one array
                    allPins = [...LatchOutputs, ...InputsPinNames];
                } else {
                    allPins = LatchOutputs;
                }

                const relationshipKeys = Object.keys(Camects[0].relationships);
                let LinkedPins = [];

                relationshipKeys.forEach((key) => {
                    if (Camects[0].relationships[key].startsWith(camect.id)) {
                        const outputMatch = allPins.filter(output => output.Pin == key);
                        // Assuming rest is already defined as an array and camect is an object with an id property

                        LinkedPins = [...LinkedPins, ...outputMatch];
                    }
                });


                // Filter out Linked pins
                const availablePins = allPins.filter(Pin => {
                    if (camectIntegrationType != 2){
                        return LinkedPins.every(LinkedPin => LinkedPin != Pin);
                    } else {
                        //Dont remove already linked pins, as you need to be able to deselct cams
                        return LinkedPins
                    }
                    
                });

                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <CametContentLayout camect={camect} LinkedPins={LinkedPins} fetchVirtualSources={fetchVirtualSources} HandleSelectCamectModalForm={HandleSelectCamectModalForm} Outputs={availablePins}/>
                    </Card>
                )
            })}

{ davantisLength > 0 && davantis[0].davantises !== null && davantis[0].relationships !== null && davantis[0].davantises.map((Davantis, index) => {

// filter out Pulse Outputs
const Outputs = OutPutsPinNames.filter((OutPut, index) => OutPut.type == 'LATCH' || OutPut.type == 'VIRTUAL_LATCH');

// Filter out output pins with assigned smartlocks
const LatchOutputs = Outputs.filter(output => {
    return iglooLocks.every(lock => !lock || lock.outputPin != output.Pin);
});

let allPins;

if (firmwareMajor == '1' && firmwareMinor >= '9' || firmwareMajor > 1) {
    // adding outputs and inputs into one array
    allPins = [...LatchOutputs, ...InputsPinNames];
} else {
    allPins = LatchOutputs;
}
console.log(davantis[0].relationships)
const relationshipKeys = Object.keys(davantis[0].relationships);
let LinkedPins = [];

relationshipKeys.forEach((key) => {
    if (davantis[0].relationships[key].startsWith(Davantis.id)) {
        const outputMatch = allPins.filter(output => output.Pin == key);
        // Assuming rest is already defined as an array and camect is an object with an id property

        LinkedPins = [...LinkedPins, ...outputMatch];
    }
});


// Filter out Linked pins
const availablePins = allPins.filter(Pin => {
    return LinkedPins.every(LinkedPin => LinkedPin != Pin);
});

return (
    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
        <DavantisContentLayout davantis={Davantis} LinkedPins={LinkedPins} fetchVirtualSources={fetchVirtualSources} HandleSelectCamectModalForm={HandleSelectCamectModalForm} Outputs={availablePins}/>
    </Card>
)
})}

            { integrations && integrations?.length > 0 && integrations?.map((integration, index) => {
                const pinName = OutPutsPinNames.find(Pin => Pin.Pin == parseInt(integration.pin))
                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <IntegrationContentLayout integration={integration} pin={pinName} fetchVirtualSources={fetchVirtualSources} successVisible={successVisible} setSuccessVisible={setSuccessVisible} />
                    </Card>
                )
            })}

            {sigfoxSensors.length > 0 && sigfoxSensors.map((sensor, index) => {
                const pinName = InputsPinNames.find(Pin => Pin.Pin == parseInt(sensor.virtualInput))
                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <SigFoxContentLayout sensor={sensor} pinName={pinName} fetchVirtualSources={fetchVirtualSources} />
                    </Card>
                )
            })}

            {efentoSensors.length > 0 && efentoSensors.map((sensor, index) => {
                const pinName = InputsPinNames.find(Pin => Pin.Pin == parseInt(sensor.virtualInput))
                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <EfentoContentLayout sensor={sensor} pinName={pinName} fetchVirtualSources={fetchVirtualSources} />
                    </Card>
                )
            })}

            

            {gateways.length > 0 && gateways.map((gateway, index) => {
                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <GatewayContentLayout gateway={gateway} fetchVirtualSources={fetchVirtualSources} />
                    </Card>
                )
            })}

            {liveViewCameras.length > 0 && liveViewCameras.map((camera, index) => {
                return (
                    <Card key={index} className={classes.cardSourcesDevices} index={index} color={null}>
                        <LiveViewContentLayout camera={camera} fetchVirtualSources={fetchVirtualSources} />
                    </Card>
                )
            })}

            
        </ul>
    )
}

export default VirtualSourcesGrid